<div class="chat-wrapper">
  <div class="side-bar card" *ngIf="leftPanel">
    <button (click)="clearChat()" class="btn btn-primary chat-btn">New Chat</button>
   </div>
  <div class="chat-box">

    <div class="chat-header" *ngIf="chatMessages.length == 0">
      <h4>Hi, I'm Deja! <br> Your smart analytics assistant. <br>
         Ask me for data, and I’ll deliver insights instantly!</h4>
   
    </div>

    <div  #scrollMe [ngClass]="{ 'dashboardv2-style': isDashboardV2, 'chat-body': !isDashboardV2 }">
      <ul class="messages">
        <ng-container *ngFor="let message of chatMessages;let i=index">
          <li *ngIf="message.role === 'user' || (message.role === 'assistant' && !message.tool_calls)"    [ngClass]="{'message-user': message.role === 'user', 'message-assistant': message.role === 'assistant'}">
            <div [ngClass]="{'bubble': message.role === 'user', 'assistant-bubble': message.role === 'assistant'}">
             
              <div class="d-flex align-items-center justify-content-between">
                <span *ngIf="message.content=='Analyzing......'" class="spinner-border spinner-border-sm mr-1" role="status"
                aria-hidden="true"></span>
                             <markdown [data]="message.content"></markdown>
           
              </div>  
              

              <div *ngIf="message.role === 'assistant'&&message.content!=='Analyzing......'&&message?.q?.length==1 " class="download-div">
                <span *ngIf="downloading[i]" class="spinner-border spinner-border-sm mr-1" role="status"
                aria-hidden="true"></span>
                <i *ngIf="!downloading[i]"(click)="downloadCsv(message.q,i)" class="feather icon-download"></i>
              </div>
    
            </div>
          </li>
        </ng-container>
      </ul>
    </div>
    
    <div class="chat-footer">
      <div  [ngClass]="{ 'dashboardv2-input': isDashboardV2, 'input-container': !isDashboardV2 }">
        <textarea [(ngModel)]="userMessage" (keydown)="handleKeyDown($event)" placeholder="Type a message..."
          class="chat-input"></textarea>
        <button (click)="sendMessage()" class="send-btn">
          <i class="feather icon-send"></i>
        </button>
      </div>
    </div>

    <div class="footer">
      <label *ngIf="!chatMessages.length" class="uat-toggle mt-1">
        <input [(ngModel)]="isDev" type="checkbox" />
        <span>UAT</span>
      </label>
      <span class="expert-text">AI-Powered Analytics Assistant</span>
    </div>

  </div>
</div>